import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PurchaseProcessService } from '../../core/services/data/purchase-process.service';

@Component({
	selector: 'app-stepper',
	templateUrl: './stepper.component.html',
	styleUrl: './stepper.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class StepperComponent {
	constructor(
		public purchaseProcessService: PurchaseProcessService,
	) {
	}

	isInactiveCurrentStep(step) {
		return !step.active || this.purchaseProcessService.currentStep === step.step;
	}

	currentStepClass(step) {
		if (this.purchaseProcessService.currentStep === step.step) return 'selected';
		return '';
	}

	isActiveStep(step) {
		return step.active && this.purchaseProcessService.currentStep !== step.step;
	}
}
